/**
 * 奖惩规则
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import RewardModal from './modal/RewardModal';
import RewardShowModal from './modal/RewardShowModal';
import PunishmentShowModal from './modal/PunishmentShowModal';



class RewardRule extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() { }

    // 新建骑手奖励
    _createRule = () => {
        this.setState({
            currentOpenMode: 'CREAT',
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        // this.props.getRewardRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }


    // 表格操作
    _tableAction = (item, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.setState({
                    currentOpenMode: 'EDITOR',
                    openModeParam: item,
                });
                break;
            case 'delete'://删除
                showConfirm('确定要删除此信息吗？', '你还要继续吗？', () => {
                    http(`/reward/rule/del/${item}/0`, {
                        id: item,
                        type: 0,
                    }, 'POST').then((response) => {
                        message.success('删除成功');
                        // this.props.getRewardRuleList(this.searchCache);//列表数据
                    }).catch((res = {}) => {
                        if (res.code == '500') {
                            message.warn(res.message);
                        }
                    });
                }, () => { });
                break;
            case 'end'://终止
                this.recordLengthEnd(item);
                break;
            case 'detail'://详情
                {
                    const { type = {}, id } = item;
                    this.setState({
                        currentOpenMode: type.code == 'REWARD' ? 'REWARD' : 'PUNISHMENT',
                        openModeParam: id
                    });
                }
                break;
        }
    }


    //请求终止数据
    recordLengthEnd = async (param) => {
        let recordLength = undefined;
        await http(`/reward/rule/conform/num/${param}`, {
            id: param
        }, 'POST').then((response) => {
            recordLength = response.result;
        }).catch((res = {}) => {
            if (res.code == '500') {
                message.warn(res.message);
            }
        });
        showConfirm('终止', `根据当前的规则，有${recordLength}条记录满足当前的规则，需要按规则执行处理么？`, () => {
            http(`/reward/rule/del/${param}/2`, {
                id: param,
                type: 2,
            }, 'POST').then((response) => {
                message.success('删除成功');
                // this.props.getRewardRuleList(this.searchCache);//列表数据
            }).catch((res = {}) => {
                if (res.code == '500') {
                    message.warn(res.message);
                }
            });
        }, () => { });
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        // this.props.getRewardRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }

    // 打开弹窗 
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'CREAT'://创建
                return <RewardModal title='新建规则' visible={true} closeMode={this._closeMode} />;
            case 'EDITOR'://编辑
                return <RewardModal title='编辑规则' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'REWARD'://奖励
                return <RewardShowModal title='规则详情' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'PUNISHMENT'://惩罚
                return <PunishmentShowModal title='规则详情' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            // this.props.getRewardRuleList(this.searchCache);// 重新渲染更新列表
        }
    }

    render() {

        return (
            <KeepAlive id='1' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建规则' onClick={this._createRule} />
                    </div>
                    <TableContent renderData={{}} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

RewardRule.propTypes = {
    history: PropTypes.object, // 路由history对象
};

const mapStateToProps = (state) => {
    return {
        // rewardRuleList: state.operatingRule.rewardRuleList,
    };
};
export default connect(mapStateToProps, null)(RewardRule);
